import { r as registerInstance, h, H as Host } from './index-97874de0.js';

const dropdownQuickActionsCss = ":host{display:flex;justify-content:center;align-items:center;margin-inline-start:1.5rem;margin-inline-end:1.5rem;margin-block-end:0.25rem}:host slot::slotted(*){display:flex;margin-inline-end:0.625rem}";
const IxDropdownQuickActionsStyle0 = dropdownQuickActionsCss;

const DropdownQuickActions = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    render() {
        return (h(Host, { key: 'd32c5fecd63fab51431f7d8c9bf5c026437b7206' }, h("slot", { key: '9abc872450d1567cdf3ee5882677182cd6ddf9b6' })));
    }
};
DropdownQuickActions.style = IxDropdownQuickActionsStyle0;

export { DropdownQuickActions as ix_dropdown_quick_actions };

//# sourceMappingURL=ix-dropdown-quick-actions.entry.js.map